
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Link } from 'react-router-dom';
import BusinessInfoContent from './BusinessInfoContent';
import LegalContent from './LegalContent';
import SocialMediaContent from './SocialMediaContent';

const ImpressumContainer = () => {
  return (
    <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
      <div className="bg-white rounded-2xl shadow-soft p-8 animate-fade-in">
        <h2 className="text-3xl font-bold text-joerg-800 mb-6">Impressum</h2>
        
        <div className="mb-6 text-sm">
          <p className="text-joerg-600">
            Weitere rechtliche Informationen: <Link to="/agb" className="text-primary hover:underline">Allgemeine Geschäftsbedingungen (AGB)</Link> | <Link to="/datenschutz" className="text-primary hover:underline">Datenschutzerklärung</Link>
          </p>
        </div>
        
        <Tabs defaultValue="business" className="mt-6">
          <TabsList className="grid w-full grid-cols-1 sm:grid-cols-3">
            <TabsTrigger value="business">Angaben</TabsTrigger>
            <TabsTrigger value="legal">Rechtliches</TabsTrigger>
            <TabsTrigger value="social">Social Media</TabsTrigger>
          </TabsList>
          
          <TabsContent value="business" className="pt-6">
            <BusinessInfoContent />
          </TabsContent>
          
          <TabsContent value="legal" className="pt-6">
            <LegalContent />
          </TabsContent>
          
          <TabsContent value="social" className="pt-6">
            <SocialMediaContent />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default ImpressumContainer;
